
<template>
    <vx-card class="limited-max-width" id="ss-seventh-step">
        <div>
            <header-step-process-component
                v-bind:step="step">
            </header-step-process-component>

            <span class="title-style modify-title" style="display:inline-block; margin-bottom:8px">Cuestionario de salud</span> <br /><br />
            <div class="subtitle-style-two">
                <span > La aseguradora necesita conocer tu estado de salud, previo a la emisión de tu seguro.</span><br />
                <span v-if="commercialOffer.telesubscription"> Puedes elegir entre contestar ahora o que el médico te llame, para hacer la encuesta durante las próximas 48 horas laborables.</span>
            </div>

                    <vs-popup  class="con-vs-popup bg-box-gradient-popup"  title="Solicitud de telesuscripción" :active.sync="callServicePopup">
                    <call-service-popup
                        v-bind:callServicePopup="callServicePopup"
                        v-bind:callServiceType="callServiceType"
                        @closeCallServicePopup="closeCallServicePopup"
                    >
                    </call-service-popup>
                </vs-popup>
                <div class="vx-row questionnaire-buttons mt-10 mb-10">
                    <div v-if="commercialOffer.questionnaireOnline">
                        <div>
                            <vs-button
                                @click="questionnaireOnline()"
                            >Contestar <br />ahora</vs-button>
                        </div>
                    </div>
                    <div v-if="commercialOffer.telesubscription">
                        <div>
                            <vs-button
                                @click="callService()"
                            >Quiero que me llamen</vs-button>
                        </div>
                    </div>
                </div>
            
                <navegation-buttons id= "buttons"
                    v-bind:code="code"
                    v-bind:previus="previus"
                    >
                </navegation-buttons>
        </div>

    </vx-card>

</template>
<script>
import VxCard from '../../components/vx-card/VxCard.vue'
import CallServicePopup from '../components/eprevision-components/callServicePopup/CallServicePopup.vue'
import HeaderStepProcessComponent from '../components/eprevision-components/header/HeaderStepProcessComponent.vue'
import NavegationButtons from '../components/eprevision-components/navegationButtons/NavegationButtons.vue'
/* eslint-disable */ 
export default {
  components: { VxCard, HeaderStepProcessComponent, NavegationButtons, CallServicePopup },
   data() {
      return {
            step: 5,
            code: this.$route.params.code,
            dataStored: null,

            formFilter: "policyHolderForm",

            // next: "social-security/seventh",
            next: "",
            previus: "",
            callServicePopup: false,
            callServiceType:"helpHealthQuestionnaire",
            commercialOffer: null

      }
  },
  created() {
        this.dataStored = JSON.parse(localStorage.getItem(this.code));
        this.initialData = this.dataStored.initialData
        this.commercialOffer = this.dataStored.commercialOffer

        if(this.dataStored.insuredData) {
            this.insuredData = this.dataStored.insuredData
            if (this.insuredData.policyholderIsInsured) {
                this.previus = "social-security/fifth"
            } else {
                this.previus = "social-security/sixth"
            }
        }

    //   this.initialData = JSON.parse(localStorage.getItem("storageDataForm"));
    //   this.commercialOffer = JSON.parse(localStorage.getItem("commercialOffer"));
        // if(localStorage.getItem("insuredData")) {
        //     this.insuredData = JSON.parse(localStorage.getItem("insuredData"))
        //     if (this.insuredData.policyholderIsInsured) {
        //         this.previus = "social-security/fourth"
        //     } else {
        //         this.previus = "social-security/fifth"
        //     }
        // }
  },
  methods: {
      
        callService() {
            this.callServicePopup = true;

        },
        closeCallServicePopup(value){
            this.callServicePopup = value;
            this.dataStored.telesubscription = true
            localStorage.setItem(this.code, JSON.stringify(this.dataStored))

            this.$vs.loading({ type: "sound" });
            this.next = "social-security/ninth-step/" + this.code
            this.goToNextStep();
        },
        questionnaireOnline() {
            this.dataStored.telesubscription = false
            localStorage.setItem(this.code, JSON.stringify(this.dataStored))

            this.$vs.loading({ type: "sound" });
            this.next = "social-security/eighth-step/" + this.code
            this.goToNextStep();
        },
        goToNextStep() {
            this.$vs.loading.close()
            // clearInterval(this.closeLoader)
            this.$router
                .push("/" + this.next )
                .catch(() => {});
        }
  }
    
}
</script>
<style lang="scss">
// #ss-seventh-step {
//     .questionnaire-buttons{
//         div{
//             margin-top:20px;
//             margin-bottom:40px;
//         }
//     }


//     #buttons .box-buttons .next-button{
//         display: none !important;
//     }

//     #buttons .box-buttons .call-button button{
//         margin-bottom: 10px !important;
//     }

// }


// @media only screen and (max-width: 400px) {
// }

// @media screen and (max-width: 497px) and  (min-width: 400px) {
// }


// @media (min-width: 601px) {
//     #ss-seventh-step {
//         #buttons .box-buttons .call-button button{
//             float: right;
//         }
//     }

// }


</style>